import { render, staticRenderFns } from "./SocialShareModal.vue?vue&type=template&id=549aa3e2&"
import script from "./SocialShareModal.vue?vue&type=script&lang=js&"
export * from "./SocialShareModal.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./SocialShareModal.vue?vue&type=style&index=0&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "4ba64327"
  
)

export default component.exports